/* eslint-disable max-len */
export default {
  signatureTypes: (state) => (reportName) => state.checklists.find((c) => c.name === reportName)?.signatureTypes ?? [],
  reportNames: (state) => state.checklists.map((c) => c.name),
};
